  <template>
  <div class="page">
    <van-cell-group>
      <input v-model="phone" type="text" placeholder="请输入手机号">
      <input v-model="icCard" type="text" placeholder="请输入卡号">
      <van-button type="primary" round block @click="bind">绑定</van-button>
    </van-cell-group>
  </div>
</template>

<script>
import API from "../utils/api";

export default {
  data() {
    return {
      phone: '',
      icCard: ''
    };
  },
  computed: {},
  methods: {
    bind() {
      if(this.phone == ""){
        this.$toast("请先输入手机号");
        return
      }
      if(this.icCard == ""){
        this.$toast("请输入卡号");
        return      
      }
      this.$post(
        `${API.bindCard}?icCard=${this.icCard}&phone=${this.phone}`
      )
        .then((res) => {
          if (res.code == 200) {
            sessionStorage.setItem("card",this.icCard)
            this.$router.push({ path: `index` });
          }else{
            this.$toast(res.msg);
          }
        })
        .catch((error) => {
          this.$toast(error);
        });
    },
  },
  created() {},
  mounted() {},
};
</script>
<style scoped>
.page{
  min-height: 100vh;
  width: 100%;
  background: linear-gradient(top,#61dec3,#fff);
}
.van-cell-group{
  position: absolute;
  top: 50%;
  left: 5%;
  right: 5%;
  transform: translate(0, -50%);
  background: none;
}
.van-cell-group input{
  width: 100%;
  margin-bottom: 20px;
  padding: 0 15px;
  height: 44px;
  line-height: 44px;
  border-radius: 100px;
}
.van-cell-group input::placeholder{
  color: #ccc;
}
.van-cell-group .van-button--primary{
  background-color: #61dec3;
  border: 1px solid #61dec3;
  font-size: 16px;
}
</style>


// WEBPACK FOOTER //
// src/pages/bind.vue